export default "__VITE_ASSET__CLwud6C3__"